import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { Layout } from './components/layout'
import { Dashboard } from './pages/dashboard'
import { Login } from './pages/login'
import { MetricDetail } from './pages/metric-detail'
import { AdminMetrics } from './pages/admin/metrics'
import { AdminGoals } from './pages/admin/goals'
import { AdminUsers } from './pages/admin/users'
import { AdminBonuses } from './pages/admin/bonuses'
import { AdminBusinessAreas } from './pages/admin/business-areas'
import { Notifications } from './pages/notifications'
import { useAuth } from './hooks/use-auth'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isAuthenticated, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-teal" />
      </div>
    )
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />
  }

  return <>{children}</>
}

function AdminRoute({ children }: { children: React.ReactNode }) {
  const { user, isLoading } = useAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-brand-teal" />
      </div>
    )
  }

  if (user?.role !== 'admin') {
    return <Navigate to="/" replace />
  }

  return <>{children}</>
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/*"
          element={
            <ProtectedRoute>
              <Layout>
                <Routes>
                  <Route path="/" element={<Dashboard />} />
                  <Route path="/metrics/:id" element={<MetricDetail />} />
                  <Route path="/notifications" element={<Notifications />} />
                  <Route
                    path="/admin/metrics"
                    element={
                      <AdminRoute>
                        <AdminMetrics />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/goals"
                    element={
                      <AdminRoute>
                        <AdminGoals />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/users"
                    element={
                      <AdminRoute>
                        <AdminUsers />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/bonuses"
                    element={
                      <AdminRoute>
                        <AdminBonuses />
                      </AdminRoute>
                    }
                  />
                  <Route
                    path="/admin/business-areas"
                    element={
                      <AdminRoute>
                        <AdminBusinessAreas />
                      </AdminRoute>
                    }
                  />
                </Routes>
              </Layout>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}
